import { render, staticRenderFns } from "./CaminoFormulario.vue?vue&type=template&id=da061cc6&scoped=true"
import script from "./CaminoFormulario.vue?vue&type=script&lang=js"
export * from "./CaminoFormulario.vue?vue&type=script&lang=js"
import style0 from "./CaminoFormulario.vue?vue&type=style&index=0&id=da061cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da061cc6",
  null
  
)

export default component.exports